import TransactionStatisticComponent from "./components/transaction-statistics/transaction-statistic.component";
import { SaleStatistic } from "./components/sale-statistics/sale-statistics";
import { PieChartStatistic } from "./components/pie-chart-statistics/pie-chart-statistics";
import { TotalStatistic } from "./components/total-statistics/total-statistics";
import "./home-screen.scss";
import { Card, Button, Dropdown, Space } from "antd";
import { IoChevronDown } from "react-icons/io5";
import type { MenuProps } from "antd";
import { useState } from "react";
const items: MenuProps["items"] = [
  {
    label: "1st menu item",
    key: "1",
  },
  {
    label: "2nd menu item",
    key: "2",
  },
  {
    label: "3rd menu item",
    key: "3",

    danger: true,
  },
  {
    label: "4rd menu item",
    key: "4",
    danger: true,
    disabled: true,
  },
];

export const HomeScreen = () => {
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    setFilterSelected(e.key);
    console.log("click", e);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const [filterSelected, setFilterSelected] = useState("30 ngày");
  return (
    <div className="home-container">
      <div className="home-filter" style={{ marginBottom: 50 }}>
        <div className="filter-container">
          <Button>Hôm qua</Button>
          <Button>Hôm nay</Button>
          <Button>Tuần này</Button>
          <Button>Tháng này</Button>
          <Button>Năm này</Button>
          <Dropdown menu={menuProps}>
            <Button type="primary">
              <Space>
                {filterSelected}
                <IoChevronDown />
              </Space>
            </Button>
          </Dropdown>
        </div>
      </div>
      <div className="home-total-statistic" style={{ marginBottom: 50 }}>
        <TotalStatistic />
      </div>
      <div className="home-transaction-statistic" style={{ marginBottom: 50 }}>
        <TransactionStatisticComponent />
      </div>
      <div className="home-sale-statistic" style={{ marginBottom: 50 }}>
        <SaleStatistic />
      </div>
      <div className="home-bar-statistic" style={{ marginBottom: 50 }}>
        <PieChartStatistic />
      </div>
    </div>
  );
};
